import { render, staticRenderFns } from "./ViewArticles.vue?vue&type=template&id=2f46ff02"
import script from "./ViewArticles.vue?vue&type=script&lang=js"
export * from "./ViewArticles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports